'use client'

import { getLocationInfo } from '@/features/locations/providers/client'
import { AirportModel } from '@/features/locations/types/models/airport.model'
import { useReservationStore } from '@/features/reservation/store'
import dynamic from 'next/dynamic'
import { useState } from 'react'

const LocationPicker = dynamic(
  () => import('@/core/lib/maps').then(res => res.LocationPicker),
  { ssr: false },
)
const MapsProvider = dynamic(
  () => import('@/core/lib/maps').then(res => res.MapsProvider),
  { ssr: false },
)

type Props = {
  field: 'from' | 'to' | null
  onClose: () => void
  onLocationChange: (field: 'from' | 'to', location: AirportModel) => void
}

export const PickOnMap: React.FC<Props> = ({
  field,
  onClose,
  onLocationChange,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const country = useReservationStore(state => state.country)
  const handlePickOnMap = async (latitude: number, longitude: number) => {
    if (!field) {
      return
    }
    try {
      setIsLoading(true)
      const place = await getLocationInfo({ latitude, longitude })
      onLocationChange(field, place)
      onClose()
    } finally {
      setIsLoading(false)
    }
  }
  if (!field) {
    return null
  }
  return (
    <MapsProvider>
      <LocationPicker
        onClose={onClose}
        isLoading={isLoading}
        className='h-100 w-full'
        onClick={({ latitude, longitude }) => {
          handlePickOnMap(latitude, longitude)
        }}
        disableBounds
        initialLocation={
          country
            ? {
                latitude: country?.latitude,
                longitude: country?.longitude,
              }
            : null
        }
      />
    </MapsProvider>
  )
}
